import DataObjectDependentsTable from "./DataObjectDependentsTable.js";
import Icons from "./Icons.js";
import LocationHash from "./LocationHash.js";

export default class Directory {
  constructor(container) {
    // Container
    this.container = container;
    if (!this.container) {
      this.error(`Failed to find element #kitmap-directory`);
    }

    this.icons = new Icons();

    // Form, keywords and results
    this.form = this.getElement("form");
    this.form.addEventListener("submit", this.searchRequestEventPreventDefault.bind(this));
    this.resultList = this.getElement(".result-list");
    this.resultSummary = this.getElement(".result-summary");
    this.keywordField = this.getElement("input[name=keywords]");
    this.spinner = this.getElement(".spinner");

    // Display keywords
    this.displayKeywordsContainer = this.getElement(".display-keywords-container");
    this.displayKeywords = this.getElement(".display-keywords");

    // List of current filters
    this.currentFiltersContainer = this.getElement(".current-filters-container");
    this.currentFiltersList = this.getElement(".current-filters-list");

    // Reset all filters button
    this.resetAllFiltersContainer = this.getElement(".reset-all-filters-container");
    this.resetAllFiltersButton = this.getElement(".reset-all-filters");
    this.resetAllFiltersButton.addEventListener("click", this.resetAllFilters.bind(this));

    // Sort bys and order bys
    this.sortBys = [
      {
        name: "Relevance",
        slug: "relevance",
        orderBy: "RelevanceScore",
        orderByDirection: "DESC",
      },
      {
        name: "Name",
        slug: "name",
        orderBy: "Name",
        orderByDirection: "ASC",
      },
      {
        name: "Recently Updated",
        slug: "newest",
        orderBy: "LastEdited",
        orderByDirection: "DESC",
      },
      {
        name: "Oldest Updated",
        slug: "oldest",
        orderBy: "LastEdited",
        orderByDirection: "ASC",
      },
    ];
    this.sortByDefault = this.sortBys[0];
    this.sortBy = this.sortByDefault;
    for (let i = 0; i < this.sortBys.length; i++) {
      let o = this.sortBys[i];
      let button = this.getElement(".sort-by-" + o.slug);
      button.addEventListener("click", this.sortByChange.bind(this, i));
      button.innerHTML = o.name;
    }

    // Page and per page
    this.page = 0;
    this.perPageDefault = 10;
    this.perPage = this.perPageDefault;
    this.paginationHolder = this.getElement(".pagination-holder");
    this.paginationPrevButton = this.getElement(".pagination-prev");
    this.paginationNextButton = this.getElement(".pagination-next");
    this.paginationPrevButton.addEventListener("click", this.paginationPrev.bind(this));
    this.paginationNextButton.addEventListener("click", this.paginationNext.bind(this));
    for (const option of this.container.querySelectorAll(".per-page-option")) {
      option.addEventListener("click", this.paginationPerPageChange.bind(this));
    }

    // Select Category
    this.selectedCategory = "all";
    this.categoryButtonResource = this.getElement(".category-button-resource");
    this.categoryButtonInfrastructure = this.getElement(".category-button-infrastructure");
    this.categoryButtonPlatform = this.getElement(".category-button-platform");
    this.categoryButtonAll = this.getElement(".category-button-all");
    this.categoryButtonResource.addEventListener("click", this.categoryButtonClicked.bind(this, "resource"));
    this.categoryButtonInfrastructure.addEventListener("click", this.categoryButtonClicked.bind(this, "infrastructure"));
    this.categoryButtonPlatform.addEventListener("click", this.categoryButtonClicked.bind(this, "platform"));
    this.categoryButtonAll.addEventListener("click", this.categoryButtonClicked.bind(this, "all"));

    // Setup Institutes
    this.allInstitutes = [];
    this.selectedInstitutes = [];
    this.selectInstitutesButtons = this.container.querySelectorAll(".institute-button");
    this.selectInstitutesCheckboxes = this.container.querySelectorAll("#accordion-institutes input[type=checkbox]");

    // Find Institutes in the big buttons if they are on the page
    for (const button of this.selectInstitutesButtons) {
      var instituteId = Number(button.getAttribute("data-id"));
      var checkbox = document.querySelector('#accordion-institutes input[type=checkbox][data-id="' + instituteId + '"]');
      this.allInstitutes.push({
        id: instituteId,
        name: this.raw2xml(button.getAttribute("data-name")),
        acronym: this.raw2xml(button.getAttribute("data-acronym")),
        button: button,
        checkbox: checkbox,
        selected: true,
      });
      this.selectedInstitutes.push(instituteId);
      button.addEventListener("click", this.toggleInstitute.bind(this));
      checkbox.addEventListener("change", this.toggleInstitute.bind(this));
    }

    // Find Institutes in the checkboxes if they are on the page
    for (const checkbox of this.selectInstitutesCheckboxes) {
      var instituteId = Number(checkbox.getAttribute("data-id"));
      var found = false;
      for (const institute of this.allInstitutes) {
        if (instituteId == institute.id) {
          found = true;
        }
      }
      if (found == false) {
        this.allInstitutes.push({
          id: instituteId,
          name: this.raw2xml(checkbox.getAttribute("data-name")),
          acronym: this.raw2xml(checkbox.getAttribute("data-acronym")),
          button: null,
          checkbox: checkbox,
          selected: true,
        });
        this.selectedInstitutes.push(instituteId);
        checkbox.addEventListener("change", this.toggleInstitute.bind(this));
      }
    }

    this.getElement(".select-all-institutes").addEventListener("click", this.selectAllInstitutesEvent.bind(this));
    this.getElement(".select-none-institutes").addEventListener("click", this.selectNoneInstitutesEvent.bind(this));

    // Field of Research
    this.fieldOfResearchCheckboxes = this.container.querySelectorAll("#accordion-field-of-research input[type=checkbox]");
    for (const checkbox of this.fieldOfResearchCheckboxes) {
      checkbox.addEventListener("click", this.selectFieldOfResearch.bind(this));
    }
    this.getElement(".clear-field-of-research").addEventListener("click", this.clearFieldOfResearchEvent.bind(this));

    // Regions
    this.regionsCheckboxes = this.container.querySelectorAll("#accordion-region input[type=checkbox]");
    for (const checkbox of this.regionsCheckboxes) {
      checkbox.addEventListener("click", this.selectRegion.bind(this));
    }
    this.getElement(".clear-location").addEventListener("click", this.clearRegionAndLocationEvent.bind(this));

    // Location
    this.locationCheckboxes = this.container.querySelectorAll("#accordion-location input[type=checkbox]");
    for (const checkbox of this.locationCheckboxes) {
      checkbox.addEventListener("click", this.selectLocation.bind(this));
    }

    // Capture clicks within the result list
    this.resultList.addEventListener("click", this.clickResultList.bind(this));

    // Location # in the url bar stores the current state of the search and filters
    this.locationHash = new LocationHash();
    window.addEventListener("hashchange", this.locationHashToForm.bind(this));
    this.locationHashToForm();
    this.searchRequest();

    // Shelves
    this.shelves = [];

    // Track previous keywords for GA search tracking
    this.previousKeywords = "";
    this.previousInstitutes = [];
  }

  /*
   * Reset all filters
   */
  resetAllFilters(event) {
    this.categoryUpdate("all");
    this.keywordField.value = "";
    this.selectAllInstitutes();
    this.updateInstitutes();
    this.resetFieldOfResearch();
    this.selectAllRegions();
    this.resetLocation();
    this.searchRequest();
  }

  /*
   * Categories selected just left of the keyword field
   */
  categoryButtonClicked(category, event) {
    event.preventDefault();
    if (this.selectedCategory === category) {
      this.categoryUpdate("all");
    } else {
      this.categoryUpdate(category);
    }
    // Flowbite needs this to close the dropdown after clicking on an option
    this.getElement("#dropdownCategoryButton").click();
    this.searchRequest();
  }

  categoryUpdate(category) {
    if (category !== "all" && category !== "platform" && category !== "infrastructure" && category !== "resource") {
      category = "all";
    }
    this.selectedCategory = category;
    this.categoryButtonResource.classList.toggle("active", category === "resource");
    this.categoryButtonInfrastructure.classList.toggle("active", category === "infrastructure");
    this.categoryButtonPlatform.classList.toggle("active", category === "platform");
    this.categoryButtonAll.classList.toggle("active", category === "all");
    let label = "All Categories";
    if (category === "platform") {
      label = "Platforms";
    } else if (category === "infrastructure") {
      label = "Infrastructure";
    } else if (category === "resource") {
      label = "Resources";
    }
    document.getElementById("selected-category").innerHTML = label;
  }

  /*
   * Take the values from the location hash and put them into the form and filters
   */
  locationHashToForm() {
    var params = this.locationHash.parse();
    if (params["keywords"]) {
      this.keywordField.value = params["keywords"];
    }
    this.setInstitutes(params["institutes"]);
    this.categoryUpdate(params["category"]);
    this.pageUpdate(params["page"]);
    this.paginationPerPageUpdate(params["per-page"]);
    this.sortByFindBySlug(params["sort-by"]);
    this.setFieldOfResearchIds(params["fields-of-research"]);
    this.setRegionIds(params["regions"]);
    this.setLocationIds(params["locations"]);
  }

  /*
   * Take the values the form and filters and put them into the location hash
   */
  formToLocationHash() {
    this.locationHash.set("keywords", this.keywordField.value);
    if (this.selectedInstitutes.length === 0 || this.selectedInstitutes.length === this.allInstitutes.length) {
      this.locationHash.set("institutes", null);
    } else {
      this.locationHash.set("institutes", this.getInstitutesForHash());
    }
    this.locationHash.set("category", this.selectedCategory === "all" ? null : this.selectedCategory);
    if (Number(this.page) === 0) {
      this.locationHash.set("page", null);
    } else {
      this.locationHash.set("page", this.page);
    }
    if (this.perPage === this.perPageDefault) {
      this.locationHash.set("per-page", null);
    } else {
      this.locationHash.set("per-page", this.perPage);
    }
    if (this.sortByDefault.slug === this.sortBy.slug) {
      this.locationHash.set("sort-by", null);
    } else {
      this.locationHash.set("sort-by", this.sortBy.slug);
    }
    this.locationHash.set("fields-of-research", this.getFieldOfResearchIds());
    this.locationHash.set("regions", this.getRegionIds());
    this.locationHash.set("locations", this.getLocationIds());
    this.locationHash.update();

    // Back to search buttons use the last saved state of the search
    sessionStorage.setItem("latestDirectoryHash", window.location.hash);
  }

  searchRequestEventPreventDefault(event) {
    event.preventDefault();
    this.searchRequest();
  }

  searchRequest() {
    // Track search keywords in Matomo only when keywords change
    const currentKeywords = this.keywordField.value.trim();
    if (currentKeywords !== this.previousKeywords) {
      this.trackSearchKeywords(currentKeywords);
      this.previousKeywords = currentKeywords;
    }

    // Track institute filter changes in Matomo
    const currentInstitutes = this.getInstitutesForSearch();
    const isAllInstitutes = currentInstitutes.length === this.allInstitutes.length;
    const institutesChanged = JSON.stringify(currentInstitutes) !== JSON.stringify(this.previousInstitutes);
    if (institutesChanged && !isAllInstitutes) {
      this.trackInstituteFilter(currentInstitutes);
      this.previousInstitutes = [...currentInstitutes];
    }

    // Show spinner, hide summary, hide result list, hide pagination
    this.spinner.style.display = "block";
    this.resultSummary.innerHTML = "";
    this.resultList.innerHTML = "";
    this.paginationHolder.style.display = "none";

    this.formToLocationHash();

    // Data to send
    const data = {
      page: this.page,
      perPage: this.perPage,
      orderBy: this.sortBy["orderBy"],
      orderByDirection: this.sortBy["orderByDirection"],
      keywords: this.keywordField.value,
      filters: {
        institutes: this.getInstitutesForSearch(),
        platform: this.selectedCategory === "platform" || this.selectedCategory === "all",
        infrastructure: this.selectedCategory === "infrastructure" || this.selectedCategory === "all",
        resource: this.selectedCategory === "resource" || this.selectedCategory === "all",
        fieldsOfResearch: this.getFieldOfResearchIds(),
        regions: this.getRegionIds(),
        locations: this.getLocationIdsForSearch(),
      },
    };

    // Abort any fetch calls that are in progress controller
    if (this.controller) {
      this.controller.abort();
    }
    this.controller = new AbortController();

    // Fetch
    const url = "/api/v1/directory/search";
    const options = {
      signal: this.controller.signal,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };

    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json();
      })
      .then((jsonData) => {
        this.searchResponse(jsonData);
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          // Ignore aborts
        } else {
          console.error("Fetch error:", error);
        }
      });
  }

  searchResponse(data) {
    // Hide spinner, show the rest
    this.spinner.style.display = "none";
    this.resultList.innerHTML = "";
    this.paginationHolder.style.display = "none";

    // Result list
    this.resultList.innerHTML = data.results.join("");

    // Result summary
    this.searchResponseUpdateSummary(data);

    // Display Keywords
    if (data.keywords.trim() === "") {
      this.displayKeywordsContainer.classList.add("hidden");
      this.displayKeywordsContainer.classList.remove("flex");
    } else {
      this.displayKeywordsContainer.classList.remove("hidden");
      this.displayKeywordsContainer.classList.add("flex");
      this.displayKeywords.innerHTML = "Search Results for: &#8216;" + data.keywords.trim() + "&#8217;";
    }

    // Current filters
    this.searchResponseCurrentFilters(data);

    // Pagination
    this.page = data.page;
    this.paginationPerPageUpdate(data.perPage);
    this.paginationHolder.style.display = data.total === 0 ? "none" : "flex";

    let paginationSummary = "";
    if (data.total === 1) {
      paginationSummary = "Showing 1 result";
    } else if (data.total <= data.perPage) {
      paginationSummary = "Showing " + data.total + " results";
    } else {
      let summaryFrom = Math.min(this.page * data.perPage + 1, data.total);
      let summaryTo = Math.min((this.page + 1) * data.perPage, data.total);
      paginationSummary =
        "Showing <span>" + summaryFrom + "</span> to <span>" + summaryTo + "</span> of <span>" + data.total + "</span> results";
    }
    this.getElement(".pagination-summary").innerHTML = paginationSummary;

    if (data.total <= data.perPage) {
      this.paginationPrevButton.style.display = "none";
      this.paginationNextButton.style.display = "none";
    } else if (this.page === 0) {
      this.paginationPrevButton.style.display = "none";
      this.paginationNextButton.style.display = "flex";
      this.paginationNextButton.classList.remove("rounded-e");
      this.paginationNextButton.classList.add("rounded");
    } else if (this.page === data.pageMax) {
      this.paginationPrevButton.style.display = "flex";
      this.paginationPrevButton.classList.remove("rounded-s");
      this.paginationPrevButton.classList.add("rounded");
      this.paginationNextButton.style.display = "none";
    } else {
      this.paginationPrevButton.style.display = "flex";
      this.paginationPrevButton.classList.remove("rounded");
      this.paginationPrevButton.classList.add("rounded-s");
      this.paginationNextButton.style.display = "flex";
      this.paginationNextButton.classList.remove("rounded");
      this.paginationNextButton.classList.add("rounded-e");
    }
  }

  searchResponseUpdateSummary(data) {
    // Result summary
    let summary = "";

    // Category singular or plural
    let categorySingle = "result";
    let categoryPlural = "results";
    if (this.selectedCategory === "platform") {
      categorySingle = "platform";
      categoryPlural = "platforms";
    } else if (this.selectedCategory === "infrastructure") {
      categorySingle = "infrastructure";
      categoryPlural = "infrastructure";
    } else if (this.selectedCategory === "resource") {
      categorySingle = "resource";
      categoryPlural = "resources";
    }

    // Institute Acronyms joined together
    let instituteAcronyms = [];
    let searchInstitutes = this.getInstitutesForSearch();
    for (let institute of this.allInstitutes) {
      if (searchInstitutes.includes(institute.id)) {
        instituteAcronyms.push(institute.acronym);
      }
    }
    let instituteName = "no institutes";
    if (instituteAcronyms.length === 1) {
      instituteName = instituteAcronyms[0];
    } else if (instituteAcronyms.length === 2) {
      instituteName = instituteAcronyms.join(" or ");
    } else if (instituteAcronyms.length === this.allInstitutes.length) {
      instituteName = "all institutes";
    } else {
      instituteName = instituteAcronyms.slice(0, -1).join(", ") + " or " + instituteAcronyms[instituteAcronyms.length - 1];
    }

    // Combined as a sentence
    if (instituteAcronyms.length === 1) {
      if (data.total === 0) {
        summary += `No ${instituteName} ${categoryPlural} found`;
      } else if (data.total === 1) {
        summary += `Showing one ${instituteName} ${categorySingle}`;
      } else {
        summary += `Showing ${data.total} ${instituteName} ${categoryPlural}`;
      }
    } else {
      if (data.total === 0) {
        summary += `No ${categoryPlural} found from ${instituteName}`;
      } else if (data.total === 1) {
        summary += `Showing one ${categorySingle} from ${instituteName}`;
      } else {
        summary += `Showing ${data.total} ${categoryPlural} from ${instituteName}`;
      }
    }

    // With keywords
    if (data.keywords.trim() !== "") {
      let keyword = "keyword";
      if (data.keywords.indexOf(" ") > -1) {
        keyword = "keywords";
      }
      summary += ` with ${keyword} <span>"${data.keywords}"</span>`;
    }
    this.resultSummary.innerHTML = summary;
  }

  searchResponseCurrentFilters(data) {
    let tags = [];
    const addTag = function (name, action) {
      tags.push({
        name: name,
        action: action,
      });
    };

    // Institutes
    if (this.areAllInstitutesSelected()) {
      addTag("All Institutes", null);
    } else {
      for (const institute of this.allInstitutes) {
        if (institute.selected) {
          addTag(institute.acronym, this.deselectInstitute.bind(this, institute.id));
        }
      }
    }

    // Fields of Research
    if (this.areAllFieldsOfResearchSelected()) {
      addTag("All Fields of Research", null);
    } else {
      for (const checkbox of this.fieldOfResearchCheckboxes) {
        if (checkbox.checked) {
          addTag(checkbox.name, this.deselectFieldOfResearch.bind(this, checkbox));
        }
      }
    }

    // Regions
    if (this.areAllRegionsSelected()) {
      addTag("All Regions", null);
    } else {
      for (const checkbox of this.regionsCheckboxes) {
        if (checkbox.checked) {
          addTag(checkbox.name, this.deselectRegion.bind(this, checkbox));
        }
      }
    }

    // Locations
    if (this.areAllLocationsSelected()) {
      addTag("All Locations Types", null);
    } else {
      for (const checkbox of this.locationCheckboxes) {
        if (checkbox.checked) {
          addTag(checkbox.name, this.deselectLocation.bind(this, checkbox));
        }
      }
    }

    // If there are no tags, hide the Current Filters:
    if (tags.length === 0) {
      this.currentFiltersContainer.classList.remove("flex");
      this.currentFiltersContainer.classList.add("hidden");
      return;
    }

    // Show Current Filters
    this.currentFiltersContainer.classList.remove("hidden");
    this.currentFiltersContainer.classList.add("flex");

    // Populate the tags
    this.currentFiltersList.innerHTML = "";
    for (const tag of tags) {
      const button = document.createElement("button");
      button.type = "button";
      if (tag.action) {
        button.innerHTML = "<span>" + tag.name + "</span>" + this.icons.currentFilterX();
        button.addEventListener("click", this.currentFilterTagClick.bind(this, tag));
      } else {
        button.innerHTML = "<span>" + tag.name + "</span>";
        button.classList.add("no-click");
      }
      this.currentFiltersList.append(button);
    }

    // Show / Hide the remove button
    if (window.location.hash === "" || window.location.hash === "#") {
      this.resetAllFiltersContainer.classList.add("hidden");
    } else {
      this.resetAllFiltersContainer.classList.remove("hidden");
    }
  }

  currentFilterTagClick(tag, event) {
    if (tag.action) {
      tag.action();
    }
  }

  /*
   * Sort and order by
   *
   * "Order By" comes from MySql conventions, its the column and the direction.
   * "Sort By" comes from the user interface, and human friendly names.
   */
  sortByChange(index, event) {
    this.sortByUpdate(this.sortBys[index]);
    // Flowbite needs this to close the dropdown after clicking on an option
    this.getElement("#sort-by-button").click();
  }

  sortByUpdate(newSortBy) {
    this.sortBy = newSortBy;
    this.getElement(".sort-by-current-name").innerHTML = this.sortBy.name;
  }

  sortByFindBySlug(slug) {
    let newSortBy = this.sortByDefault;
    for (const o of this.sortBys) {
      if (o.slug === slug) {
        newSortBy = o;
      }
    }
    this.sortByUpdate(newSortBy);
  }

  /*
   * Pagination
   */
  paginationPrev() {
    this.page -= 1;
    this.searchRequest();
  }

  paginationNext() {
    this.page += 1;
    this.searchRequest();
  }

  paginationPerPageChange(event) {
    this.paginationPerPageUpdate(event.target.innerHTML);
    // Flowbite needs this to close the dropdown after clicking on an option
    this.getElement("#per-page-button").click();
  }

  paginationPerPageUpdate(n) {
    n = Number(n);
    if (Number.isNaN(n)) {
      n = 10;
    }
    this.getElement(".per-page-current-name").innerHTML = n;
    this.perPage = n;
  }

  pageUpdate(n) {
    n = Number(n);
    if (Number.isNaN(n)) {
      n = 0;
    }
    this.page = n;
  }

  /*
   * Institutes
   */
  setInstitutes(fromHash) {
    if (typeof fromHash !== "string") {
      this.selectedInstitutes = [];
    } else {
      this.selectedInstitutes = fromHash
        .split(",")
        .map((item) => parseInt(item.trim(), 10))
        .filter(Number.isInteger);
      if (this.selectedInstitutes.length === 0) {
        this.selectAllInstitutes();
      }
      this.updateInstitutes();
    }
  }

  getInstitutesForHash() {
    let sortedInstitutes = this.selectedInstitutes.sort((a, b) => a - b);
    return sortedInstitutes.join(",");
  }

  getInstitutesForSearch() {
    let searchInstitutes = this.selectedInstitutes;
    if (searchInstitutes.length === 0) {
      for (const institute of this.allInstitutes) {
        searchInstitutes.push(institute.id);
      }
    }
    let sortedInstitutes = searchInstitutes.sort((a, b) => a - b);
    return sortedInstitutes;
  }

  toggleInstitute(event) {
    let instituteId = event.target.getAttribute("data-id");
    for (let institute of this.allInstitutes) {
      if (institute.id == instituteId) {
        institute.selected = !institute.selected;
      }
    }
    this.updateSelectedInstitutes();
  }

  deselectInstitute(instituteId, event) {
    for (let institute of this.allInstitutes) {
      if (institute.id == instituteId) {
        institute.selected = false;
      }
    }
    this.updateSelectedInstitutes();
  }

  updateSelectedInstitutes() {
    this.selectedInstitutes = [];
    for (let institute of this.allInstitutes) {
      if (institute.selected) {
        this.selectedInstitutes.push(institute.id);
      }
    }
    this.updateInstitutes();
    if (this.selectedInstitutes.length !== 0) {
      this.searchRequest();
    }
  }

  selectAllInstitutesEvent(event) {
    event.preventDefault();
    this.selectAllInstitutes();
    this.updateInstitutes();
    this.searchRequest();
  }

  selectNoneInstitutesEvent(event) {
    event.preventDefault();
    this.selectNoneInstitutes();
    this.updateInstitutes();
  }

  areAllInstitutesSelected() {
    for (const institute of this.allInstitutes) {
      if (institute.selected === false) {
        return false;
      }
    }
    return true;
  }

  selectAllInstitutes() {
    this.selectedInstitutes = [];
    for (const institute of this.allInstitutes) {
      this.selectedInstitutes.push(institute.id);
    }
  }

  selectNoneInstitutes() {
    this.selectedInstitutes = [];
  }

  raw2xml(unsafe) {
    return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }

  updateInstitutes() {
    for (let institute of this.allInstitutes) {
      if (this.selectedInstitutes.includes(institute.id)) {
        institute.selected = true;
        if (institute.button) {
          institute.button.classList.add("selected");
        }
        institute.checkbox.checked = true;
      } else {
        institute.selected = false;
        if (institute.button) {
          institute.button.classList.remove("selected");
        }
        institute.checkbox.checked = false;
      }
    }
  }

  /*
   * Fields of Research from the sidebar - select all = null = do not apply this filter
   */
  selectFieldOfResearch(event) {
    let checkbox = event.target;
    let level1 = checkbox.classList.contains("level-1");
    let level2 = checkbox.classList.contains("level-2");

    // Level 1 checkboxes toggle all their children
    if (level1) {
      let children = checkbox.parentNode.parentNode.parentNode.querySelectorAll("input[type=checkbox]");
      for (const child of children) {
        child.checked = checkbox.checked;
      }
    }

    // Level 2 checkboxes toggle all their children
    if (level2) {
      let parent = checkbox.parentNode.parentNode.parentNode.querySelector("input[type=checkbox]");
      let siblings = checkbox.parentNode.parentNode.querySelectorAll("input[type=checkbox]");
      let anyChecked = false;
      for (const sibling of siblings) {
        if (sibling.checked) {
          anyChecked = true;
        }
      }
      parent.checked = anyChecked;
    }

    this.searchRequest();
  }

  areAllFieldsOfResearchSelected() {
    for (const checkbox of this.fieldOfResearchCheckboxes) {
      if (checkbox.checked === false) {
        return false;
      }
    }
    return true;
  }

  ifNoFieldsOfResearchSelectAll() {
    for (const checkbox of this.fieldOfResearchCheckboxes) {
      if (checkbox.checked) {
        return;
      }
    }
    this.selectAllFieldsOfResearch();
  }

  selectAllFieldsOfResearch() {
    for (const checkbox of this.fieldOfResearchCheckboxes) {
      checkbox.checked = true;
    }
  }

  getFieldOfResearchIds() {
    let all = true;
    let ids = [];
    for (const checkbox of this.fieldOfResearchCheckboxes) {
      if (checkbox.checked) {
        ids.push(checkbox.getAttribute("value"));
      } else {
        all = false;
      }
    }
    return all ? null : ids;
  }

  setFieldOfResearchIds(fromHash) {
    if (fromHash === undefined || fromHash === null) {
      this.resetFieldOfResearch();
      return;
    }
    let idsFromHash = fromHash.split(",");
    for (const checkbox of this.fieldOfResearchCheckboxes) {
      checkbox.checked = idsFromHash.includes(checkbox.value);
    }
  }

  resetFieldOfResearch() {
    for (const checkbox of this.fieldOfResearchCheckboxes) {
      checkbox.checked = true;
    }
  }

  deselectFieldOfResearch(checkbox, event) {
    checkbox.checked = false;
    this.ifNoFieldsOfResearchSelectAll();
    this.searchRequest();
  }

  clearFieldOfResearchEvent(event) {
    event.preventDefault();
    this.clearFieldOfResearch();
    this.searchRequest();
  }

  clearFieldOfResearch() {
    for (const checkbox of this.fieldOfResearchCheckboxes) {
      checkbox.checked = false;
    }
  }

  /*
   * Regions from the sidebar - select all = null = do not apply this filter
   */
  selectRegion(event) {
    let checkbox = event.target;
    let value = checkbox.getAttribute("value");
    let siblings = checkbox.parentNode.parentNode.querySelectorAll("input[type=checkbox]");
    var allCheckbox = siblings[0];
    if (value === "ALL") {
      for (const sibling of siblings) {
        sibling.checked = checkbox.checked;
      }
    } else {
      let allChecked = true;
      for (let i = 0; i < siblings.length; i++) {
        let sibling = siblings[i];
        if (sibling.checked === false && i !== 0) {
          allChecked = false;
        }
      }
      allCheckbox.checked = allChecked;
    }
    this.ifNoLocationsSelectedSelectAll();
    this.searchRequest();
  }

  clearRegion() {
    for (const checkbox of this.regionsCheckboxes) {
      checkbox.checked = false;
    }
  }

  clearRegionAndLocationEvent(event) {
    this.clearRegion();
    this.clearLocation();
    this.searchRequest();
  }

  deselectRegion(checkbox, event) {
    checkbox.checked = false;
    this.ifNoRegionsSelectedSelectAll();
    this.searchRequest();
  }

  getRegionIds() {
    let all = true;
    let ids = [];
    for (let i = 0; i < this.regionsCheckboxes.length; i++) {
      if (i !== 0) {
        let checkbox = this.regionsCheckboxes[i];
        if (checkbox.checked) {
          ids.push(checkbox.getAttribute("value"));
        } else {
          all = false;
        }
      }
    }
    return all ? null : ids;
  }

  setRegionIds(fromHash) {
    if (fromHash === undefined || fromHash === null) {
      this.selectAllRegions();
      return;
    }
    let slugsFromHash = fromHash.split(",");
    for (const checkbox of this.regionsCheckboxes) {
      checkbox.checked = slugsFromHash.includes(this.locationHash.slugify(checkbox.value));
    }
  }

  ifNoRegionsSelectedSelectAll() {
    for (const checkbox of this.regionsCheckboxes) {
      if (checkbox.checked) {
        return;
      }
    }
    this.selectAllRegions();
  }

  selectAllRegions() {
    for (const checkbox of this.regionsCheckboxes) {
      checkbox.checked = true;
    }
  }

  areAllRegionsSelected() {
    for (const checkbox of this.regionsCheckboxes) {
      if (checkbox.checked === false) {
        return false;
      }
    }
    return true;
  }

  /*
   * Location from the sidebar - select all = null = do not apply this filter
   */

  ifNoLocationsSelectedSelectAll() {
    for (const checkbox of this.locationCheckboxes) {
      if (checkbox.checked) {
        return;
      }
    }
    this.selectAllLocations();
  }

  selectAllLocations() {
    let siblings = document.querySelectorAll("#accordion-location input[type=checkbox]");
    for (const sibling of siblings) {
      sibling.checked = true;
    }
  }

  selectLocation(event) {
    let checkbox = event.target;
    let value = checkbox.getAttribute("value");
    let siblings = document.querySelectorAll("#accordion-location input[type=checkbox]");
    var allCheckbox = siblings[0];
    if (value === "ALL") {
      for (const sibling of siblings) {
        sibling.checked = checkbox.checked;
      }
    } else {
      let allChecked = true;
      for (let i = 0; i < siblings.length; i++) {
        let sibling = siblings[i];
        if (sibling.checked === false && i !== 0) {
          allChecked = false;
        }
      }
      allCheckbox.checked = allChecked;
    }
    this.ifNoRegionsSelectedSelectAll();
    this.searchRequest();
  }

  resetLocation() {
    for (const checkbox of this.locationCheckboxes) {
      checkbox.checked = true;
    }
  }

  clearLocation() {
    for (const checkbox of this.locationCheckboxes) {
      checkbox.checked = false;
    }
  }

  deselectLocation(checkbox, event) {
    checkbox.checked = false;
    this.ifNoLocationsSelectedSelectAll();
    this.searchRequest();
  }

  getLocationIds() {
    let all = true;
    let ids = [];
    for (let i = 0; i < this.locationCheckboxes.length; i++) {
      if (i !== 0) {
        let checkbox = this.locationCheckboxes[i];
        if (checkbox.checked) {
          ids.push(checkbox.getAttribute("value"));
        } else {
          all = false;
        }
      }
    }
    return all ? null : ids;
  }

  getLocationIdsForSearch() {
    let all = [];
    let selected = [];
    for (let i = 0; i < this.locationCheckboxes.length; i++) {
      if (i !== 0) {
        let checkbox = this.locationCheckboxes[i];
        let id = checkbox.getAttribute("value");
        all.push(id);
        if (checkbox.checked) {
          selected.push(id);
        }
      }
    }
    if (selected.length === 0 || selected.length === all.length) {
      return null;
    }
    return selected;
  }

  setLocationIds(fromHash) {
    if (fromHash === undefined || fromHash === null) {
      this.resetLocation();
      return;
    }
    let slugsFromHash = fromHash.split(",");
    for (const checkbox of this.locationCheckboxes) {
      checkbox.checked = slugsFromHash.includes(this.locationHash.slugify(checkbox.value));
    }
  }

  areAllLocationsSelected() {
    for (const checkbox of this.locationCheckboxes) {
      if (checkbox.checked === false) {
        return false;
      }
    }
    return true;
  }

  /*
   * Capture clicks inside the result list
   */
  clickResultList(event) {
    let button = event.target;

    // If we clicked a shelf button
    if (button.classList.contains("shelf-button")) {
      event.preventDefault();
      let resultPanel = button.closest(".result-panel");
      let shelfElement = resultPanel.querySelector(".data-object-dependents-table");

      // Create the shelf if it doesn't exist
      if (shelfElement === null) {
        this.shelves.push(new DataObjectDependentsTable(resultPanel, this.shelves.length));
      } else {
        // If it does exist, toggle it open or closed
        for (const shelf of this.shelves) {
          if (shelf.index == shelfElement.getAttribute("data-index")) {
            shelf.toggleOpen();
          }
        }
      }
    }
  }

  /*
   * Helpers
   */
  getElement(query) {
    const element = this.container.querySelector(query);
    if (!element) {
      this.error(`Failed to find the element with '${query}'`);
    }
    return element;
  }

  error(message) {
    console.error("Kitmap Directory", message);
  }

  log(message) {
    console.log("Kitmap Directory", message);
  }

  /*
   * Track search keywords in Matomo
   */
  trackSearchKeywords(keywords) {
    if (keywords.trim() === '') {
      return;
    }
    const _paq = window._paq = window._paq || [];
    _paq.push(['trackSiteSearch', keywords, 'directory_search', false]);
  }

  /*
   * Track institute filter changes in Matomo
   */
  trackInstituteFilter(instituteIds) {
    const _paq = window._paq = window._paq || [];
    for (const id of instituteIds) {
      const institute = this.allInstitutes.find((i) => i.id === id);
      const name = institute ? institute.acronym : String(id);
      _paq.push(['trackEvent', 'directory_search', 'institute_filter', name]);
    }
  }
}
